// store/slices/selectionSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Site } from './siteSlice';

interface SelectionState {
  selectedType: string | null;
  selectedCustomerId: string | null;
  selectedSiteId: string | null;
  selectedSiteName: string | null;
  selectedGDM: string | null;
  selectedSiteObject: Site | null;  // Store complete site object
  selectedLocationId: string | null;
  selectedLocationName: string | null;
  initialLoad: boolean | null;
}

const initialState: SelectionState = {
  selectedType: 'customers',
  selectedCustomerId: null,
  selectedSiteId: null,
  selectedSiteName: null,
  selectedSiteObject: null,
  selectedLocationId: null,
  selectedLocationName: null,
  initialLoad: false,
  selectedGDM: null,
};

const selectionSlice = createSlice({
  name: 'selection',
  initialState,
  reducers: {
    setSelectedCustomer: (state, action: PayloadAction<any | null>) => {
      console.log('Setting selected customer to:', action.payload);
      // state.selectedCustomerId = action.payload;
      state.selectedType = action.payload.type;
      state.selectedCustomerId = action.payload.id;
      // Clear dependent selections when customer changes
      state.selectedSiteId = null;
      state.selectedSiteObject = null;
      state.selectedLocationId = null;
      state.selectedGDM = null;
    },
    setSelectedSite: (state, action: PayloadAction<string | null>) => {
      state.selectedSiteId = action.payload;
      // Clear dependent selections when site changes
      state.selectedLocationId = null;
    },
    setSelectedSiteGDM: (state, action: PayloadAction<string | null>) => {
      state.selectedGDM = action.payload;
    },
    setSelectedSiteName: (state, action: PayloadAction<string | null>) => {
      console.log('Setting selected site name to:', action.payload);
      state.selectedSiteName = action.payload;
      // Clear dependent selections when site changes
      state.selectedLocationId = null;
    },
    setSelectedSiteObject: (state, action: PayloadAction<Site | null>) => {
      state.selectedSiteObject = action.payload;
      if (action.payload) {
        state.selectedSiteId = action.payload.site_id;
        state.selectedSiteName = action.payload.site_name || null;
        state.selectedGDM = action.payload.gdm_customer_number || null;
      }
    },
    setSelectedLocation: (state, action: PayloadAction<{id: string, name: string } | null>) => {
      state.selectedLocationId = action.payload?.id as string;
      state.selectedLocationName = action.payload?.name as string;
    },
    setInitialLoad: (state, action: PayloadAction<boolean | null>) => {
      state.initialLoad = action.payload;
    },
    clearAllSelections: (state) => {
      state.selectedCustomerId = null;
      state.selectedSiteId = null;
      state.selectedSiteName = null;
      state.selectedSiteObject = null;
      state.selectedLocationId = null;
      state.selectedLocationName = null;
      state.initialLoad = false;
      state.selectedGDM = null;
    },
  },
});

export const {
  setSelectedCustomer,
  setSelectedSite,
  setSelectedSiteName,
  setSelectedSiteObject,
  setSelectedLocation,
  setInitialLoad,
  clearAllSelections,
  setSelectedSiteGDM
} = selectionSlice.actions;

export default selectionSlice.reducer;

